export { RESTService } from './http-rest.service';
export { HttpInterceptorService } from './interceptors/http-interceptor.service';
export { CovalentHttpModule } from './http.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/http/index.js
// module id = ../../../../@covalent/http/index.js
// module chunks = 4